import type { ReactNode } from "react";
import { Button, Center, Paper, Stack, Text, Title } from "@mantine/core";
import { useAuth } from "./AuthProvider";
import {
  hasRequiredPermissions,
  type PermissionRequirement,
} from "./permissionPolicy";

interface PermissionRouteProps extends PermissionRequirement {
  children: ReactNode;
  fallback?: ReactNode;
  homeHref?: string;
}

export function PermissionRoute({
  children,
  fallback,
  homeHref = "/",
  ...requirement
}: PermissionRouteProps) {
  const { permissions } = useAuth();

  if (hasRequiredPermissions(permissions, requirement)) {
    return <>{children}</>;
  }

  if (fallback !== undefined) {
    return <>{fallback}</>;
  }

  return (
    <Center mih="60vh" px="md">
      <Paper
        maw={520}
        p="xl"
        withBorder
        role="alert"
        aria-labelledby="permission-route-title"
      >
        <Stack align="center" gap="md">
          <Title id="permission-route-title" order={2} ta="center">
            Access not granted
          </Title>
          <Text c="dimmed" ta="center">
            Your account does not have permission to open this workspace. Ask
            your lab manager if your responsibilities require access.
          </Text>
          <Button component="a" href={homeHref}>
            Return to dashboard
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
